import { RESET_REMARKS, RemarksActionTypes, SET_REMARKS } from '../actions/remarksActionTypes';

export const initialState = '';
const remarks = (state: string = initialState, action: RemarksActionTypes): string => {
	switch (action.type) {
		case SET_REMARKS:
			// Redux does not support to return undefined. null is not supported in the FormFieldTextArea poncho
			// component as input. Hence the check to return '' otherwise.
			return action.payload ? action.payload : '';
		case RESET_REMARKS:
			return initialState;
		default:
			return state;
	}
};

export default remarks;
